import { VFC, useState } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import Add from '@mui/icons-material/Add'
import { categoryFilterKeyTranslations } from '../../types'

interface AddFilterButtonProps {
    keys: readonly string[]
    disabledKeys: readonly string[]
    onAddFilter: (key: string) => void
}

const AddFilterButton: VFC<AddFilterButtonProps> = ({ keys, disabledKeys, onAddFilter }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    return (
        <>
            <Button startIcon={<Add />} onClick={handleClick}>
                Ajouter un filtre
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {keys.map((key) => (
                    <MenuItem
                        key={key}
                        onClick={() => {
                            onAddFilter(key)
                            handleClose()
                        }}
                        disabled={disabledKeys.includes(key)}
                    >
                        {categoryFilterKeyTranslations[key] || key}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default AddFilterButton
